import { render, staticRenderFns } from "./ResetNotify.vue?vue&type=template&id=02d297f0&lang=pug&"
import script from "./ResetNotify.vue?vue&type=script&lang=js&"
export * from "./ResetNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports